export const MAP = ['lowestPrice', 'bestValue', 'topBrand']
export const TITLES = ['Lowest Price', 'Best Value', 'Top Brands']
